import { useEffect, useState } from "react";
import { Modal } from "components/designV2/modal/modal";
import { TextArea } from "components/designV2/textarea/textarea";
import { PrimaryButton } from "components/designV2/buttons/primaryButton";
import { SecondaryButton } from "components/designV2/buttons/secondaryButton";
import { ColorV2 } from "config/colors";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

interface DeclineModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDecline: (comment: string) => Promise<boolean> | boolean | void;
  isSubmitting?: boolean;
}

const DECLINE_BUTTON_STYLES = {
  backgroundColor: ColorV2.NegativeRed,
  hoverBackgroundColor: ColorV2.DeclinedRed,
  activeBackgroundColor: ColorV2.DeclinedRed,
  textColor: ColorV2.White,
  borderColor: "transparent",
  iconColor: ColorV2.White,
};

export const DeclineModal: React.FC<DeclineModalProps> = (props) => {
  const { t } = useTranslation();
  const [comment, setComment] = useState("");

  useEffect(() => {
    if (!props.isOpen) return;
    setComment("");
  }, [props.isOpen]);

  const handleSubmit = async (): Promise<void> => {
    if (props.isSubmitting) return;
    const result = await Promise.resolve(props.onDecline?.(comment.trim()));
    if (result === false) return;
    props.onClose();
  };

  return (
    <Modal
      label={t("Schedule.Decline")}
      isOpen={props.isOpen}
      onClose={props.onClose}
      size="small"
      showCloseButton={false}
      contentOverflow="visible"
      footer={
        <ActionRow>
          <SecondaryButton
            label={t("CompanyTimeReport.Cancel")}
            onClick={props.onClose}
          />
          <PrimaryButton
            label={t("Schedule.Decline")}
            iconName="v2/cross"
            styleOverrides={DECLINE_BUTTON_STYLES}
            isLoading={props.isSubmitting}
            disabled={props.isSubmitting}
            onClick={handleSubmit}
          />
        </ActionRow>
      }
    >
      <ModalBody>
        <TextArea
          label={t("Schedule.Comment")}
          value={comment}
          onChange={setComment}
          placeholder={t("Schedule.Comment")}
          maxHeight={240}
        />
      </ModalBody>
    </Modal>
  );
};

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
`;

const ActionRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  width: 100%;
`;
